import {
  ACTION_EDIT_PAGE_NAME__REQUEST,
  ACTION_EDIT_PAGE_NAME__SUCCESS,
  ACTION_EDIT_PAGE_NAME__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_EDIT_PAGE_NAME__REQUEST:
    case ACTION_EDIT_PAGE_NAME__SUCCESS:
      return null;

    case ACTION_EDIT_PAGE_NAME__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
